<template>   
    <v-app ref="app" 
        id="qplus" 
        class="app"
    >
        <Main v-if="language" 
            :class="{ 
                'iOS': is_iOS,
                'Safari': is_Safari
            }"
        />
    </v-app>
</template>

<script>
    import { get_init_locale } from '@/i18n/init.js'
    import { 
        get_mobile_operating_system, 
        get_computer_operating_system 
    } from '@/utils/common/mobile.js'
    import { mapState, mapGetters, mapMutations } from "vuex";
    
    import Main from '@/components/main.vue'

    export default {
        name: 'App',

        components: {
            Main,
        },

        data() {
            return {
                is_iOS: get_mobile_operating_system() === 'iOS',
                is_Safari: get_computer_operating_system() === 'Safari'
            }
        },
        
        computed: {
            ...mapState([
                'language'
            ]),

            ...mapGetters([
                'is_activate_i18n',
            ]),
        },

        created() {
            this.init_current_custom_version()
            this.init_language()
        },

        methods: {
            ...mapMutations([
                'set_language',
                'set_client_name'
            ]),

            init_current_custom_version() {
                let client_name = "DEMO"
                const current_host = window.location.href.match('http(s?)://.*?/(.*)/');
                if (current_host) {
                    client_name = current_host[2]
                }
                this.set_client_name(client_name)
            },

            init_language() {
                if(this.is_activate_i18n) {
                    const lang = get_init_locale()
                    return this.set_language(lang)
                }

                this.set_language('tw')
            }
        }
    }

</script>

<style lang="scss">
    #qplus {
        width: 100vw;
        font-family: NotoSansCJKtc, Microsoft JhengHei, Meiryo, Arial, Verdana, sans-serif !important;
    }

    [v-cloak] {
        display: none;
    }

    #body_bg_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background-position: bottom center;
        background-size: cover;
        background-color: #337ab7;
        z-index: -1;
    }

    /* scroll */

    /* scroll背景 */
    ::-webkit-scrollbar-track {
        background-color: transparent;
    }

    /* scroll條 */
    ::-webkit-scrollbar-thumb {
        background-color: #b3b7c4;
        border-radius: 4px;
        opacity: .64;
        box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, .24);
    }

    ::-webkit-scrollbar {
        width: .75rem;

        &:horizontal {
            height: .5rem;
        }
    }
</style>

<style scoped>
    .app >>> .v-application--wrap {
        z-index: 0;
    }
</style>